import { PropsWithChildren } from "react";

export const SectionContainer = ({ children }: PropsWithChildren) => {
  return (
    <div className="px-4 py-4 justify-around w-full max-w-7xl mx-auto">
      {children}
    </div>
  );
};
